/** Se muestra cuando alguien visita /reservas sin indicar el slug de una
 * clinica (la URL correcta es /reservas/{slug}). Evita que caiga en el
 * catch-all que redirige al login del panel interno. */
export default function PublicBookingNotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F3F0EA] px-6" data-testid="public-booking-not-found">
      <div className="text-center max-w-md">
        <h1 className="font-serif text-3xl text-[#2D2926] mb-3">Enlace de reserva incompleto</h1>
        <p className="text-[#5C554D]">
          Esta URL necesita el nombre de la clinica, por ejemplo: <span className="font-medium">/reservas/nombre-de-tu-clinica</span>.
          Revisa el enlace que te compartieron.
        </p>
      </div>
    </div>
  );
}
